<template>
  <div id="app9">
      <header>
        <Navbar/>
      </header>
  </div>
</template>

<script>
import Navbar from './components/Navbar';

export default {
  name: 'App',
  components: {
    Navbar,
  }
}
</script>
